import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feathericons',
  templateUrl: './feathericons.component.html',
  styleUrls: ['./feathericons.component.scss']
})
export class FeathericonsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
